import { APICallV3Post } from 'reactApp/api/APICall';

export class R7ViewApiAPICall extends APICallV3Post {
    _method = 'r7/view';
}
